/** Derive analytics confidence scores from real data coverage (not hardcoded constants). */

const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

export const OSH_POLICY_TARGET = 85;

export const deriveDataCoverageConfidence = ({
  totalUnits = 0,
  unitsWithData = 0,
  anchorMetric = null,
}) => {
  const coverage = totalUnits > 0 ? (unitsWithData / totalUnits) * 100 : 0;
  const qualityBoost =
    typeof anchorMetric === "number" && Number.isFinite(anchorMetric)
      ? Math.min(20, anchorMetric * 0.15)
      : 0;
  if (totalUnits <= 0 || unitsWithData <= 0) return 0;
  return clamp(Math.round(coverage * 0.9 + qualityBoost), 0, 96);
};

export const deriveDropoutConfidence = (summary, blocks = []) => {
  const totalBlocks = summary?.total_blocks || blocks.length || 0;
  const withRates = blocks.filter((b) => typeof b.dropout_rate === "number").length;
  const avgRate = Number(summary?.avg_dropout_rate ?? 0);
  return deriveDataCoverageConfidence({
    totalUnits: totalBlocks,
    unitsWithData: withRates,
    anchorMetric: avgRate > 0 ? Math.min(100, 100 - avgRate * 8) : null,
  });
};

export const deriveMapConfidence = (rows = [], metricKey) => {
  const numeric = rows
    .map((r) => r?.[metricKey])
    .filter((v) => typeof v === "number" && Number.isFinite(v));
  const avg = numeric.length ? numeric.reduce((a, b) => a + b, 0) / numeric.length : null;
  return deriveDataCoverageConfidence({
    totalUnits: rows.length,
    unitsWithData: numeric.length,
    anchorMetric: avg,
  });
};

export const deriveExecutiveMetricsConfidence = (metrics = {}) => {
  let filled = 0;
  const checks = [
    metrics.schools > 0,
    metrics.students > 0,
    metrics.teachers > 0,
    Number(metrics.apaar_rate) > 0,
    Number(metrics.classroom_health) > 0,
    Number(metrics.toilet_functional) > 0,
    Number(metrics.dropout_rate) >= 0,
    Number(metrics.teacher_quality) > 0,
  ];
  filled = checks.filter(Boolean).length;
  const completeness = (filled / checks.length) * 100;
  if (filled === 0) return 0;
  return clamp(Math.round(completeness * 0.95), 0, 95);
};

export const deriveRecommendationConfidence = (metrics = {}, index = 0) => {
  const base = deriveExecutiveMetricsConfidence(metrics);
  if (base <= 0) return 0;
  return clamp(base - index * 4, 0, 94);
};

export const formatLakhs = (n) => {
  if (typeof n !== "number" || !Number.isFinite(n)) return "—";
  if (n >= 100000) return `${(n / 100000).toFixed(2)} Lakh`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return n.toLocaleString("en-IN");
};
